import React from "react";
import { Link } from "react-router-dom";
import "../../style/component/layout/Footer.css";
import { useFooterTracking } from "../../hooks/websiteHooks";
import { useTranslation } from "../../contexts/TranslationContext";
import { resolveImageSrc } from "../../utils/resolveImageSrc";

function Footer() {
  // Initialize footer link tracking
  useFooterTracking();
  const { t } = useTranslation();
  const handleAboutUsClick = (e) => {
    e.preventDefault();
    window.location.href = "/";
  };
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-center">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/";
            }}
            className="logo"
          >
            <img src={resolveImageSrc("favicon.ico")} alt="Vietqubit logo" className="logo-icon" />
            <span>Vietqubit</span>
          </a>
        </div>

        <div className="footer-bottom">
          <p className="footer-description">{t("footer.description")}</p>
          <div className="footer-links">
            <Link to="/admin/login" data-track="footer-admin-login">
              {t("footer.adminLogin") || "Admin"}
            </Link>
            <a href="/" onClick={handleAboutUsClick} className="nav-link">
              {t("nav.about_us") || "About Us"}
            </a>
            <Link to="/terms" data-track="footer-terms">
              {t("footer.terms")}
            </Link>
            <Link to="/privacy" data-track="footer-privacy">
              {t("footer.privacy")}
            </Link>
            <Link to="/brand" data-track="footer-brand">
              {t("footer.brand")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
